import { Component, ReactNode } from 'react'

interface Rectangle {
  readonly width: number
}

export interface Element {
  readonly getBoundingClientRect: () => Rectangle
  readonly parentElement:
    | null
    | (Element & {
        readonly scrollWidth: number
        readonly clientWidth: number
      })
  readonly offsetWidth: number
  readonly scrollWidth: number
}

interface ChildProps {
  readonly registerElement: (el: Element | null) => void
  readonly doesOverflowParent: () => boolean
}

interface Props {
  readonly children: (props: ChildProps) => ReactNode
}

export class OverflowDetector extends Component<Props> {
  private element: Element

  public render() {
    return this.props.children({
      registerElement: this.registerElement,
      doesOverflowParent: this.doesOverflowParent
    })
  }

  private registerElement = (el: Element) => {
    this.element = el
  }

  private doesOverflowParent = () => {
    if (!(this.element && this.element.parentElement)) {
      return false
    }

    // First validation (works in FF and Chrome)
    if (
      this.element.getBoundingClientRect().width >
        this.element.parentElement.getBoundingClientRect().width ||
      this.element.offsetWidth < this.element.scrollWidth
    ) {
      return true
    }

    // A second validation is used in order to support IE11 and EDGE
    // since getBoundingClientRect (used in the first validation) is
    // returning different results in these browsers
    return (
      Math.abs(
        this.element.parentElement.scrollWidth -
          this.element.parentElement.clientWidth
      ) > 1
    )
  }
}
